{
  "version": 1,
  "asset_id": "bf8241ff-79c0-404a-9dd2-801b1325bb62",
  "project_id": "63ffb125-aed4-4f54-959a-0b116fa77b1d",
  "url": "/__l5e/assets-v1/bf8241ff-79c0-404a-9dd2-801b1325bb62/sleeve-amateur-1-440.webp",
  "r2_key": "a/v1/63ffb125-aed4-4f54-959a-0b116fa77b1d/bf8241ff-79c0-404a-9dd2-801b1325bb62/sleeve-amateur-1-440.webp",
  "original_filename": "sleeve-amateur-1-440.webp",
  "size": 9008,
  "content_type": "image/webp",
  "created_at": "2026-09-29T01:15:31Z"
}
